import {  CampaignService, InputName } from '../types';

export interface DisabledFields {
    customerType: boolean,
    searchPremise: boolean,
    searchService: boolean,
    searchExpert: boolean,
    extraFilters: boolean
}
/**
 * If requiredInOrder is configured this function controls which fields should be disabled at different times.
 * For example if requiredInOrder is ["customerType", "searchService"] then we have following scenarios
 * 1. CustomerType is not set, then all other fields than customertype are disabled
 * 2. CustomerType is set, but searchService is empty, then customerType and searchService are enabled other fields are disabled
 * 3. CustomerType and searchServie are set, then all fields are enabled
 */
export const getDisabledFields = (
    customerType: string,
    selectedServices: CampaignService[],
    requiredInOrder: InputName[] | undefined): DisabledFields => {
    let result = {
        customerType: true,
        searchPremise: true,
        searchService: true,
        searchExpert: true,
        extraFilters: true,
    };
    if(requiredInOrder) {
        for(const t of requiredInOrder) {
            if (t === 'customerType') {
                result = {
                    ...result,
                    customerType: false
                };
                if(customerType.length === 0) {
                    return result;
                }
            }
            if (t === 'searchService') {
                result = {
                    ...result,
                    searchService: false
                };
                if(selectedServices.length === 0) {
                    return result;
                }
            }
        }
    }

    return {
        customerType: false,
        searchPremise: false,
        searchService: false,
        searchExpert: false,
        extraFilters: false,
    };
};